import { Component, OnInit, inject } from '@angular/core';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatCardModule} from '@angular/material/card';
import {MatButtonModule} from '@angular/material/button';
import {MatTableModule} from '@angular/material/table';
import { MatPaginatorModule} from '@angular/material/paginator';
import {MatIconModule} from '@angular/material/icon';

import { Store } from '@ngrx/store';
import { CommonModule } from '@angular/common';
import { ContactDetailsActions } from '@store/actions/contact-details/contact-details.actions';
import {
  selectContactDetailsInfo,
  selectContactDetailsData
} from '@store/selectors/contact-details/contact-details.selectors';
import { FormsModule } from '@angular/forms';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef, GridOptions} from 'ag-grid-community';
import { EditDeleteRendererComponent } from '@components/shared/edit-delete-renderer/edit-delete-renderer.component';
import { MatDialog } from '@angular/material/dialog';
import { myCustomTheme } from '../../constants/grid-themes';


@Component({
  selector: 'app-contact-details',
  imports: [
    FormsModule,
    MatInputModule,
    MatCardModule,
    AgGridAngular,
    CommonModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './contact-details.component.html',
  styleUrl: './contact-details.component.css'
})
export class ContactDetailsComponent implements OnInit  {

  private readonly store = inject(Store);
    readonly dialog = inject(MatDialog);
    theme = myCustomTheme;
    private gridApi: any;
    private gridColumnApi: any;
    public gridOptions: GridOptions = {
      pagination: true,
      paginationPageSize: 20,
      suppressClickEdit: true,
      editType: "fullRow",
      onGridReady: this.onGridReady.bind(this),
    };
    colDefs: ColDef[] = [];
    defaultColDef: ColDef = {
      flex: 1,
      filter: true,
      editable: false,
    };
    
  dataSource$ = this.store.select(selectContactDetailsData);

  ngOnInit() {
    this.store.dispatch(ContactDetailsActions.contactDetailsComponentLoaded());
  }

    onGridReady(params: any) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.setColDefs();
    }

    setColDefs() {
      this.colDefs = [
        {
          field: "name",
          headerName: "Name",
          tooltipField: "name"
        },
        {
          field: "role",
          headerName: 'Roles',
          tooltipField: "role"
        },
        {
          field: "emailAddress",
          headerName: 'Email',
          tooltipField: "emailAddress"
        },
        { field: "phoneNumber",
          
          tooltipField: "phoneNumber"
        },
        {
          field: "actions",
          filter: false,
          maxWidth: 150,
          width: 50,
          editable: false,
          suppressNavigable: true,
          cellRenderer: EditDeleteRendererComponent,
          cellRendererParams: {
            showDelete: true,
            showEdit: true

          }
        },
      ];
    }

  addContactButtonPressed() {
    this.store.dispatch(ContactDetailsActions.openAddContactPressed());
  }

  onCellClicked(params: any) {
        if (
          params.column.colId === "actions" &&
          params.event.target.dataset.action
        ) {
          let action = params.event.target.dataset.action;
          if (action === "edit") {
            this.store.dispatch(ContactDetailsActions.openEditContactPressed({contact: params.data}))
          } else if (action === "delete") {
            this.store.dispatch(ContactDetailsActions.openDeleteContactPressed({name: params.data.name, id: params.data.id}))
          }
        }
  }
}
